import {createGlobalStyle, DefaultTheme, GlobalStyleComponent} from 'styled-components'
import {Colors, DispWidthSize, FontWeights, LineHeight} from './Constants'
import 'normalize.css'

export const GlobalStyleResident: GlobalStyleComponent<{}, DefaultTheme> = createGlobalStyle`

  html {
    font-size: 62.5%;
    min-width: ${DispWidthSize.MinWidth};
  }

  @font-face {
    font-family: "icon-hsc_sutekinet";
    src: url(/resources/fonts/icon-hsc_sutekinet.eot);
    src: url(/resources/fonts/icon-hsc_sutekinet.eot?#iefix) format("embedded-opentype"),
    url(/resources/fonts/icon-hsc_sutekinet.woff) format("woff"),
    url(/resources/fonts/icon-hsc_sutekinet.ttf) format("truetype");
    font-weight: normal;
    font-style: normal;
  }

  body {
    font-family: "Noto Sans JP", sans-serif;
    font-size: 1.6em;
    font-weight: ${FontWeights.Normal};
    line-height: ${LineHeight.Basic};
    color: ${Colors.Body};
    word-break: break-all;
  }

  html, p, #root {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    height: 100%;
  }

`
